import React from 'react'
import {Divider, makeStyles, Tab} from '@material-ui/core';
import PropTypes from 'prop-types';
import TabsUI from '@material-ui/core/Tabs';
import Typography from "./Typography";

const useStyle = makeStyles(theme => ({
    root: {},
    divider: {
        margin: `0 ${-theme.spacing(2)}px ${theme.spacing(2)}px`
    },
    tab: {
        flexGrow: '1'
    },
    tabVertical: {
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "end",
        textTransform: "none",
        "&>.MuiSvgIcon-root": {
            marginLeft: theme.spacing(1)
        },
        "&>.MuiTypography-root": {
            flexGrow: 1
        }
    },
    tabVerticalSelected: {
        backgroundColor: theme.palette.background.greyBackground,
        borderRadius: `${theme.shape.borderRadius}px 0 0 ${theme.shape.borderRadius}px`,
    },
    tabsVertical: {
        borderRight: `1px solid ${theme.palette.divider}`,
        marginRight: theme.spacing(2)
    }
}))

function Tabs(
    {
        tabs,
        value,
        onChange,
        children,
        vertical
    }) {
    const classes = useStyle();

    return (
        <>
            <TabsUI
                className={classes.root}
                classes={{
                    root: vertical ? classes.tabsVertical : undefined
                }}
                value={value}
                onChange={(event, newValue) => onChange(newValue)}
                indicatorColor='primary'
                orientation={vertical ? "vertical" : undefined}
            >
                {tabs.map(({
                               label,
                               value,
                               disabled,
                               icon
                           }) => {
                    return (
                        <Tab
                            key={value}
                            className={classes.tab}
                            classes={{
                                wrapper: vertical ? classes.tabVertical : null,
                                selected: vertical ? classes.tabVerticalSelected : null
                            }}
                            label={<Typography component="span">{label}</Typography>}
                            value={value}
                            disabled={disabled}
                            icon={icon}
                        />
                    )
                })}
            </TabsUI>
            {!vertical && <Divider className={classes.divider}/>}
            {children}
        </>
    )
}

Tabs.propTypes = {
    tabs: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired,
        icon: PropTypes.element,
        disabled: PropTypes.bool
    }))
}

export default Tabs;